var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { ActivityDayContainer } from '../ActivityDayContainer';
import { Tooltip } from '@hn-ui/tooltips';
var MAX_TIME_VISIBLE = 99;
var ScDayContainer = styled(ActivityDayContainer).withConfig({ displayName: "ScDayContainer", componentId: "sc-1uud7qv" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &[data-active='true'] {\n    background: ", ";\n  }\n"], ["\n  &[data-active='true'] {\n    background: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.blue80;
});
var EducationalDay = function (_a) {
    var timeSpent = _a.timeSpent;
    if (!timeSpent || timeSpent === 0) {
        return (_jsx(Tooltip, __assign({ content: 'No practice', maxWidth: 'none' }, { children: _jsx(ScDayContainer, { isActive: false, focusable: true }, void 0) }), void 0));
    }
    return (_jsx(Tooltip, __assign({ content: "Practice time: " + timeSpent + " min", maxWidth: 'none' }, { children: _jsx(ScDayContainer, __assign({ isActive: true, focusable: true }, { children: simplifyTime(timeSpent) }), void 0) }), void 0));
};
var simplifyTime = function (time) {
    return time >= MAX_TIME_VISIBLE ? MAX_TIME_VISIBLE + "+" : time;
};
export { EducationalDay };
var templateObject_1;
